import React, { Component } from 'react';
import Item from './item.js';
import Tooltip from '../tooltip/tooltip';

import './image-map.scss';

class ImageMap extends Component {
	state = { hoveredArea: null };
	constructor(props) {
		super(props);
		this.handleHover = this.handleHover.bind(this);
	}

	handleHover(hoveredArea) {
		this.setState({ hoveredArea });
	}

	render() {
		const { id, image, viewBox, mapping, labels } = this.props;

		return (
			<div className="image-map">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox={viewBox}>
						<defs>
							<filter id="filter">
								<feColorMatrix
									in="SourceGraphic"
									type="matrix"
									values="0.55  0     0     0     0
										0     0.62  0     0     0
										0     0     0.69  0     0
										0     0     0     0.5   0 "
								/>
							</filter>
							{mapping.map(itemDef => (
								<mask key={itemDef.id} id={`mask-${itemDef.id}`}>
									<path
										id={`path-${itemDef.id}`}
										d={itemDef.path}
										fill="white"
									/>
								</mask>
							))}
							<image
								xlinkHref={image}
								id={`photo-${id}`}
								width="100%"
								height="100%"
							/>
						</defs>

						<use xlinkHref={`#photo-${id}`} filter="url(#filter)" />

						{mapping.map(item => (
							<Item
								key={item.id}
								imageId={id}
								id={item.id}
								onHover={this.handleHover}
							/>
						))}
					</svg>
				<div>
					{mapping.map(item => (
						<Tooltip
							key={item.id}
							place={item.place}
							position={item.position}
							show={this.state.hoveredArea === item.id}
						>
							{labels[item.id]}
						</Tooltip>
					))}
				</div>
			</div>
		);
	}
}

export default ImageMap;
